module.exports = "/_next/static/images/team-staffing-expansion-service-1-9032af13be5501fd11e41669e9d772ab.webp";